import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 曼顿接口---旧版本已经作废的
 **********************************************************************************/
export default {
	/**
	 * 通过虚拟设备no获取对应的曼顿设备no
	 */
	getDeviceByVirtualDeviceNos: (nos, success, failure) => {
		Axios.post('/mandun/getDeviceByVirtualDeviceNos.do', {
			nos
		}, success, failure);
	},
	/**
	 * 控制设备开关
	 */
	OcSwitchDeviceByAddrs: (projectCode,mac,isOpen,addrs, success, failure) => {
		Axios.post('/mandun/OcSwitchDeviceByAddrs.do', {
			projectCode,mac,isOpen,addrs
		}, success, failure);
	},
	/**
	 * 定制的获取三栋楼指定日期负荷记录
	 */
	getMandunDayLoadHistory: (timeStamp, success, failure) => {
		Axios.post('/mandun/getMandunDayLoadHistory.do', {
			timeStamp
		}, success, failure);
	},
	xiruiCountMacDevice: (unitId, success, failure) => {
		Axios.post('/iot/countMacDevice.do', {
			unitId
		}, success, failure);
	},
}
